import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SideMenu.css';

const primaryLinks = [
	{
		label: 'How to Play',
		path: '/how-to-play',
		description: 'Rules, tips, and scoring basics.',
	},
	{
		label: 'Nolan Challenge',
		path: '/challenge',
		description: 'Timed quote challenge mode.',
	},
	{
		label: 'Leaderboard',
		path: '/leaderboard/Nolan',
		description: 'See top Nolan challenge scores.',
	},
];

const menuLinks = [
	{
		label: 'About Us',
		path: '/about',
		description: 'What Movie Quotes Guesser is and how it works.',
	},
	{
		label: 'Contact Us',
		path: '/contact',
		description: 'Get in touch with the team or report issues.',
	},
	{
		label: 'Privacy Policy',
		path: '/privacy',
		description: 'How we handle data, cookies, and analytics.',
	},
	{
		label: 'Terms & Conditions',
		path: '/terms',
		description: 'Rules, responsibilities, and legal terms.',
	},
];

function SideMenu() {
	const [isOpen, setIsOpen] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		if (!isOpen) return undefined;
		const handleEscape = (event) => {
			if (event.key === 'Escape') setIsOpen(false);
		};
		window.addEventListener('keydown', handleEscape);
		return () => window.removeEventListener('keydown', handleEscape);
	}, [isOpen]);

	const handleNavigate = (path) => {
		setIsOpen(false);
		navigate(path);
	};

	return (
		<div className="side-menu">
			<button
				type="button"
				className="menu-button"
				aria-label="Open menu"
				aria-expanded={isOpen}
				aria-controls="side-menu-drawer"
				onClick={() => setIsOpen(true)}
			>
				<span className="menu-bar" />
				<span className="menu-bar" />
				<span className="menu-bar" />
			</button>

			<div id="side-menu-drawer" className={`side-drawer ${isOpen ? 'open' : ''}`} role="dialog">
				<div className="side-drawer-header">
					<h3 className="side-drawer-title">Menu</h3>
					<button type="button" className="drawer-close" onClick={() => setIsOpen(false)}>
						Close
					</button>
				</div>
				<div className="side-drawer-body">
					<p className="drawer-intro">
						Official pages for Movie Quotes Guesser and our policies.
					</p>
					<div className="drawer-links">
						{primaryLinks.map((link) => (
							<button
								key={link.path}
								type="button"
								className="drawer-link"
								onClick={() => handleNavigate(link.path)}
							>
								<span className="drawer-link-title">{link.label}</span>
								<span className="drawer-link-description">{link.description}</span>
							</button>
						))}
						<div className="drawer-links-spacer" />
						{menuLinks.map((link) => (
							<button
								key={link.path}
								type="button"
								className="drawer-link"
								onClick={() => handleNavigate(link.path)}
							>
								<span className="drawer-link-title">{link.label}</span>
								<span className="drawer-link-description">{link.description}</span>
							</button>
						))}
					</div>
				</div>
			</div>

			{isOpen && <button className="side-drawer-backdrop" type="button" onClick={() => setIsOpen(false)} />}
		</div>
	);
}

export default SideMenu;
